module.exports = __webpack_public_path__ + "img/presentation-chart_swap-092326.004fa65a.jpg";